import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import TodoListUrl from '../SubHeader/TodoListUrl';
import PlaceholderUrl from '../SubHeader/PlaceholderUrl';
import ComponentOrderUrl from '../SubHeader/ComponentOrderUrl';
import LibraryTemplateURL from '../SubHeader/LibraryTemplateURL';
import DevorderUrl from '../SubHeader/DevorderUrl';
import SupplierUrl from '../SubHeader/SupplierUrl';

function MainNabBar(props) {
  const host = window.location.origin;
  const {
    mastersAccess,
    mainMenu,
    reportsRight,
    pathName,
    productsAccess,
    moduleAccess,
    isSupplierLoggedIn,
    PIMRight,
    checkModulePermission,
    manualsAccess,
    manualDocsRight,
    componentOrderRight,
    DAMRight,
    librariesAccess,
    suggestionRight,
    supplierPermission,

    t,
    productDetails,
    createConditionalComponent,
    userRights,
  } = props;
  const location = useLocation();

  const { state, search } = location;
  const queryParams = new URLSearchParams(search);
  const querySupplierId = queryParams.get('supplierId');
  const btnNavActiveClass = 'btn-nav active';
  const supplierSuggestionPath = '/supplier-suggestion';
  const [activeParentMenu, setActiveParentMenu] = useState('');
  const [isGradingsPresent, setIsGradingsPresent] = useState(false);
  const handleNavigation = (activeMenu) => {
    if (activeParentMenu !== activeMenu) {
      setActiveParentMenu(activeMenu);
    } else {
      setActiveParentMenu('');
    }
  };
  const SupplierOverviewAccessComp = createConditionalComponent(userRights, 'supplierOverview');

  useEffect(() => {
    if (productDetails?.gradingGroups?.length > 0) {
      setIsGradingsPresent(true);
    } else {
      setIsGradingsPresent(false);
    }
  }, [productDetails]);
  return (
    <ul className={`mobile-navigation nav-ul open ${mainMenu && 'open'}`}>
      {reportsRight && (
        <li>
          <button type="button" onClick={() => handleNavigation('reports')} className={`${activeParentMenu === 'reports' && 'active'} btn-nav`}>
            {t('TOP_NAVBAR.REPORTS')}
          </button>
          {activeParentMenu === 'reports' && <TodoListUrl isMobileMenu pathName={pathName} imageWidth={72} />}
        </li>
      )}

      {productsAccess && (
        <>
          <li>
            <button
              type="button"
              onClick={() => handleNavigation('productInformation')}
              className={`${activeParentMenu === 'productInformation' && 'active'} btn-nav`}
            >
              {t('TOP_NAVBAR.PRODUCT_INFORMATION')}
            </button>
            {(() => {
              if (activeParentMenu === 'productInformation') {
                if (pathName.includes('/development-order/')) {
                  return <DevorderUrl isGradingsPresent={isGradingsPresent} isMobileMenu />;
                }
                return <PlaceholderUrl isMobileMenu />;
              }
              return null;
            })()}
          </li>

          {moduleAccess?.pimAccess && !isSupplierLoggedIn && PIMRight && (
            <li>
              <Link className={`${pathName?.includes('pim-v2') && 'active'}`} to="/pim-v2/templates">
                {t('PLACEHOLDER_URL.PIM')}
              </Link>
            </li>
          )}

          {moduleAccess?.damAccess && DAMRight && !isSupplierLoggedIn && (
            <li>
              <Link
                className={
                  [
                    '/digital-assets-management',
                    '/digital-assets-management/folder',
                    '/digital-assets-management/history',
                    '/digital-assets-management/add',
                    '/digital-assets-management/edit',
                    'digital-assets-management/folder/edit',
                    'digital-assets-management/folder/add',
                  ]?.some((path) => pathName?.startsWith(path))
                    ? btnNavActiveClass
                    : 'btn-nav'
                }
                to="/digital-assets-management"
              >
                {t('TOP_NAVBAR.DAM')}
              </Link>
            </li>
          )}

          {!isSupplierLoggedIn && checkModulePermission('componentOrder') && componentOrderRight && (
            <li>
              <button
                type="button"
                onClick={() => handleNavigation('componentOrder')}
                className={`${activeParentMenu === 'componentOrder' && 'active'} btn-nav`}
              >
                {t('TOP_NAVBAR.COMPONENT_ORDERS')}
              </button>
              {activeParentMenu === 'componentOrder' && <ComponentOrderUrl isMobileMenu />}
            </li>
          )}
        </>
      )}

      {!isSupplierLoggedIn && librariesAccess && (
        <li>
          <button
            type="button"
            onClick={() => handleNavigation('libraryGroupTemplate')}
            className={`${activeParentMenu === 'libraryGroupTemplate' && 'active'} btn-nav`}
          >
            {t('TOP_NAVBAR.LIBRARIES_GROUP_MOBILE')}
          </button>
          {activeParentMenu === 'libraryGroupTemplate' && <LibraryTemplateURL isMobileMenu />}
        </li>
      )}
      {!isSupplierLoggedIn && (
        <SupplierOverviewAccessComp>
          <li>
            <button
              type="button"
              onClick={() => handleNavigation('partnerOverview')}
              className={`${activeParentMenu === 'partnerOverview' && 'active'} btn-nav`}
            >
              {t('navbar.menu5')}
            </button>
            {activeParentMenu === 'partnerOverview' && <SupplierUrl isMobileMenu state={{ ...state, supplierId: querySupplierId }} />}
          </li>
        </SupplierOverviewAccessComp>
      )}

      {!isSupplierLoggedIn && suggestionRight && (
        <li>
          <Link className={pathName?.indexOf(supplierSuggestionPath) > -1 ? btnNavActiveClass : 'btn-nav'} to={supplierSuggestionPath}>
            {t('TOP_NAVBAR.SUPLIER_SUGGESTION')}
          </Link>
        </li>
      )}
      {isSupplierLoggedIn && suggestionRight && supplierPermission && (
        <li>
          <Link className={pathName?.indexOf(supplierSuggestionPath) > -1 ? btnNavActiveClass : 'btn-nav'} to={supplierSuggestionPath}>
            {t('TOP_NAVBAR.SUPLIER_SUGGESTION')}
          </Link>
        </li>
      )}

      {manualsAccess && manualDocsRight && (
        <li>
          <a className={pathName?.indexOf('/documents') > -1 ? btnNavActiveClass : 'btn-nav'} href={`${host}/documents`}>
            {t('TOP_NAVBAR.MANUAL_DOCUMENT')}
          </a>
        </li>
      )}
      {!isSupplierLoggedIn && mastersAccess && (
        <li>
          <Link className={pathName?.indexOf('/masters') > -1 ? btnNavActiveClass : 'btn-nav'} to="/masters">
            {t('TOP_NAVBAR.SYSTEM_MASTER')}
          </Link>
        </li>
      )}
    </ul>
  );
}

export default MainNabBar;
